import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// Invite team member
export const inviteTeamMemberClient = createAsyncThunk(
  "teamMember/invitations/invite",
  async (data) => {
    const response = await api.post("/team-members/invitations/invite", data);
    return response.data;
  }
);

// Get My Own company members
export const getTeamMembers = createAsyncThunk(
  "team-members/invitations/my-team",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/team-members/invitations/my-team");
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch team members"
      );
    }
  }
);

// Get comapny other members as a company member
export const getCompanyTeamMembers = createAsyncThunk(
  "/team-members/invitations/companies/getCompanyTeamMembers",
  async (companyId) => {
    const response = await api.get(
      `/team-members/invitations/companies/${companyId}/team`
    );
    return response.data;
  }
);

// Validate invitation token
export const validateInvitationToken = createAsyncThunk(
  "team-members/invitations/validate",
  async (token, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/team-members/invitations/validate-invitation/${token}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Invalid or expired invitation"
      );
    }
  }
);

// Remove team member
export const removeTeamMemberClient = createAsyncThunk(
  "teamMember/invitations/remove",
  async (memberId, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/team-members/invitations/remove/${memberId}`
      );
      return { memberId, message: response.data?.message };
    } catch (err) {
      // Extract the error message from the response
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data?.error?.message ||
        err.message ||
        "Failed to remove team member";

      console.log("Backend error:", errorMessage);

      return rejectWithValue({
        message: errorMessage,
        code: err.response?.status || 500,
      });
    }
  }
);

export const acceptInvitationExistingUser = createAsyncThunk(
  "teamMember/invitations/acceptInvitation",
  async (token) => {
    const response = await api.post(
      "/team-members/invitations/accept-invitation",
      { token }
    );
    return response.data;
  }
);
